<p>
  administrador-visualizacion works!
</p>
Hola {{ element }}

{{ element.categoria }}
{{ element.id_categoria }}
{{ element.color }}
<hr />